import config from "environment";
import { getRequest, postRequest } from "./client";
import {
  createCanonicalId,
  findAppConfigById,
  getAppFromUrl,
  LinkAppConfig,
  LinkRecord,
} from "winslow-core";
import {
  apiCreateLinkRecordPayload,
  apiGetLinkRecordForCanonicalIdInWorkspacePayload,
  apiUpdateLinkRecordPayload,
  apiAddLinkRecordTagPayload,
} from "./LinkRecordService.types";

const { baseApi } = config;

export async function apiCreateLinkRecord(
  payload: apiCreateLinkRecordPayload
): Promise<LinkRecord | null> {
  const fetchURL = `${baseApi}/shares/create-link-record`;
  return await postRequest(fetchURL, payload, "API/apiCreateLinkRecord");
}

// get one full link record
export async function apiGetLinkRecord(
  linkRecordId: string
): Promise<LinkRecord | null> {
  const fetchURL = `${baseApi}/shares/link-record/${linkRecordId}`;
  return await getRequest(fetchURL, "API/apiGetLinkRecord");
}

export async function apiGetLinkRecordForCanonicalIdInWorkspace(
  payload: apiGetLinkRecordForCanonicalIdInWorkspacePayload
): Promise<LinkRecord | null> {
  const fetchURL = `${baseApi}/shares/link-record-canonical`;
  return await postRequest(
    fetchURL,
    payload,
    "API/apiGetLinkRecordForCanonicalIdInWorkspace"
  );
}

export async function apiAddLinkRecordTag(
  payload: apiAddLinkRecordTagPayload
): Promise<LinkRecord> {
  const fetchURL = `${baseApi}/shares/add-link-record-tag`;
  return await postRequest(fetchURL, payload, "API/apiAddLinkRecordTag");
}

export async function apiUpdateLinkRecord(
  payload: apiUpdateLinkRecordPayload
): Promise<LinkRecord | null> {
  const fetchURL = `${baseApi}/shares/link-record/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdateLinkRecord");
}

export async function apiDeleteLinkRecord(
  linkRecordId: string
): Promise<LinkRecord | null> {
  const fetchURL = `${baseApi}/shares/delete-link-record/${linkRecordId}`;
  return await getRequest(fetchURL, "API/apiDeleteLinkRecord");
}

//don't love it here but will refactor later
export const getLinkRecordFromUrl = async (
  url: string,
  workspaceId: string,
  supportedApps: LinkAppConfig[]
): Promise<LinkRecord | null> => {
  try {
    const newLinkAppConfig = getAppFromUrl(
      url,
      supportedApps ? supportedApps : []
    );

    console.log("newLinkAppConfig", newLinkAppConfig);

    if (newLinkAppConfig === "NOT_VALID_URL") {
      console.log("invalid url: " + newLinkAppConfig);
      return null;
    }

    let canonicalId: string | undefined = "";

    if (newLinkAppConfig === "APP_CONFIG_NOT_FOUND") {
      const otherApp = findAppConfigById(
        "OTHER",
        supportedApps ? supportedApps : []
      );

      if (otherApp) {
        canonicalId = url;
      }
    } else {
      canonicalId = createCanonicalId(url, newLinkAppConfig);
    }

    if (workspaceId && canonicalId) {
      const theExistingLinkRecord =
        await apiGetLinkRecordForCanonicalIdInWorkspace({
          workspaceId,
          canonicalId,
        } as apiGetLinkRecordForCanonicalIdInWorkspacePayload);

      return theExistingLinkRecord;
    }
  } catch {
    console.log("[getLinkRecordFromUrl] do not like that url: '" + url + "'");
    return null;
  }

  return null;
};
